import { FC } from 'react';
import { TwoFaSectionTitle } from '../../../shared/TwoFaSectionTitle';
import { TwoFaSectionDescription } from '../../../shared/TwoFaSectionDescription';
import { DeleteTwoFaOnClose } from '../../utils/types';
import { TwoFaSectionButtonsWrapper } from '../../../shared/TwoFaSectionButtonsWrapper';
import { ButtonBase } from '../../../../../ButtonBase/ButtonBase';
import { TwoFaContentWrap } from '../../../shared/TwoFaContentWrap';
import { TwoFaScreenTranslations } from '../../utils/get2faTranslations';

const ResetTwoFaConfirmationScreen: FC<{
  onClose: DeleteTwoFaOnClose;
  translations: TwoFaScreenTranslations;
}> = ({ onClose, translations }) => {
  return (
    <>
      <TwoFaContentWrap>
        <TwoFaSectionTitle title={translations.reset2faSuccessDescription} />
        <TwoFaSectionDescription
          textContent={translations.reset2faSuccessDescriptionBody}
        />
      </TwoFaContentWrap>
      <TwoFaSectionButtonsWrapper>
        <ButtonBase onClick={onClose} visual="primary" size="large" fullWidth>
          {translations.done}
        </ButtonBase>
      </TwoFaSectionButtonsWrapper>
    </>
  );
};

export { ResetTwoFaConfirmationScreen };
